import { type FC } from "react";

import { Text } from "@mantine/core";
import { clsx } from "clsx";

import { type SubmissionQuota } from "../../models/SubmissionQuota";

import { QuotaSeverityIcon } from "./QuotaSeverityIcon";
import { type SubmissionQuotaContext } from "./SubmissionQuotaContext";
import styles from "./SubmissionQuotaInline.module.css";
import { SubmissionQuotaRemainingText } from "./SubmissionQuotaRemainingText";
import { SubmissionQuotaResetTooltip } from "./SubmissionQuotaResetTooltip";
import { SubmissionQuotaUpsell } from "./SubmissionQuotaUpsell";

interface SubmissionQuotaInlineProps {
    quota: SubmissionQuota | null;
    context: SubmissionQuotaContext;
    isMuted?: boolean;
}

export const SubmissionQuotaInline: FC<SubmissionQuotaInlineProps> = ({ quota, context, isMuted = false }) => {
    if (!quota) {
        return null;
    }

    return (
        <div
            className={clsx(styles.container, isMuted ? styles.muted : styles[quota.severity])}
            data-testid={`submission-quota-inline-${quota.severity}`}
            data-muted={isMuted || undefined}
        >
            <span className={styles.summary} role="status">
                <QuotaSeverityIcon severity={quota.severity} />
                <Text component="span" size="xs" fw={500}>
                    <SubmissionQuotaRemainingText context={context} quota={quota} />
                </Text>
                {quota.replenishAt ? <SubmissionQuotaResetTooltip context={context} quota={quota} /> : null}
            </span>
            {isMuted ? null : <SubmissionQuotaUpsell quota={quota} context={context} />}
        </div>
    );
};
